// Avery's trademark guidelines (notice 2026-09, escalated 2026-10): wherever the
// UI shows their brand or a product number whose status they confirmed, show
// the mark. Display only — catalogue data and search keep the plain text.

const CONFIRMED_NUMBERS = /(?<![\w.\-/®])(5160|5163|8160|22807)(?![\w®\-/])/g

/** "Avery" → "Avery®", "Avery Zweckform" → "Avery Zweckform®", 5160 → 5160®. */
export function markBrand(text: string): string {
  return text
    .replace(/\bAvery(?: Zweckform)?\b(?!®)/g, '$&®')
    .replace(CONFIRMED_NUMBERS, '$1®')
}

/** Avery's required disclaimer, verbatim. */
export const AVERY_DISCLAIMER =
  'This program is not made, tested or endorsed by Avery Products Corporation. ' +
  'Avery and all Avery brands, product names and codes are trademarks of CCL Label, Inc.'

/** True when any of these catalogue items is shown under an Avery brand. */
export function showsAvery(items: { brand?: string }[]): boolean {
  return items.some((x) => /^avery/i.test(x.brand ?? ''))
}

/** The disclaimer as one small muted line. Shown only while Avery items are on
 *  screen (callers toggle `hidden`), always as full visible text — Avery
 *  requires the disclaimer to be included, so it is never behind a tooltip. */
export function averyDisclaimerEl(): HTMLElement {
  const p = document.createElement('p')
  p.className = 'text-[10px] leading-snug text-slate-500 mt-3'
  p.dataset.testid = 'avery-disclaimer'
  p.textContent = AVERY_DISCLAIMER
  return p
}
